import React, { Component } from 'react'
import Header from './Bootstrap/Header'
import Chatbot from './Chatbot/Chatbot.js'

class App extends Component {
  state = {
   
  }
  render() {
    return (
      <div className="App">
      <Header containerClass="justify-content-center" dark={true}>
          ChatBot Without AI
        </Header>
      <Chatbot/>
      
      
      </div>

    )
  }
}


export default App;
